module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-container"
  }, [_c('div', {
    attrs: {
      "name": "messages-list"
    }
  }, _vm._l((_vm.messages), function(message) {
    return _c('div', {
      key: message.id,
      staticClass: "message",
      attrs: {
        "title": _vm.title(message)
      }
    }, [_c('div', {
      class: ['status', _vm.statusClass(message)]
    }), _vm._v(" "), _c('div', {
      staticClass: "username"
    }, [_vm._v(_vm._s(message.username))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e8880e5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marker/MessageGroupList.vue
// module id = 1042
// module chunks = 1